import type { IconData } from '../../types';

export const data: IconData = {
  o: '<path d="M480-424 277-221q-12 12-28 12t-28-12q-12-12-12-28t12-28l203-203-203-203q-12-12-12-28t12-28q12-12 28-12t28 12l203 203 203-203q12-12 28-12t28 12q12 12 12 28t-12 28L536-480l203 203q12 12 12 28t-12 28q-12 12-28 12t-28-12L480-424Z"/>',
  f: '<path d="M480-424 277-221q-12 12-28 12t-28-12q-12-12-12-28t12-28l203-203-203-203q-12-12-12-28t12-28q12-12 28-12t28 12l203 203 203-203q12-12 28-12t28 12q12 12 12 28t-12 28L536-480l203 203q12 12 12 28t-12 28q-12 12-28 12t-28-12L480-424Z"/>',
};

export default data;
